//Imports
import React, { Fragment, useEffect } from 'react';
import { IntlProvider } from 'react-intl';
import { Routes, Route, Navigate } from 'react-router-dom';
import 'Assets/sass/site.scss';
import { useSelector } from 'react-redux';
import { useDataDogViewTracking } from 'Core/hooks/useDataDogViewTracking';


//Definitions
import locales from 'Locales';

//Components
import LoginView from 'Core/views/login'
import LoginSocialMedia from 'Core/views/loginSocialMedia'
import ForgotPasswordView from 'Core/views/forgotPassword'
import ConfirmUserView from 'Core/views/confirmUser'
// import MigrateUserViewLegacy from 'Core/views/migrateUserLegacy'
import ErrorView from 'Core/views/error'
import SharedVideoView from 'Core/views/sharedVideo';
import SharedMediaView from 'Core/views/sharedMedia';
import SharedLiveVideoSecView from 'Core/views/sharedLiveVideoSec'
import VideoAlertView from 'Core/views/videoAlert';
import AlertLogView from 'Core/views/alertLog';
import EtaLink from 'Core/views/etaLink';
import DebugUnit from 'Core/views/debugUnit';
import Test from 'Core/views/test';
import ForceChangePassword from 'Core/views/forceChangePassword';
import ShortCodesView from 'Core/views/shortCodes';
import ModulesRoutes from 'Modules'
import LiveIncident from 'Core/views/incident';
import DownloadReportView from "Core/views/downloadReport";
import { NotificationContainer } from "Components/Notifications";

import 'Assets/sass/site.scss';
// import 'bootstrap/dist/css/bootstrap.min.css';


import { ThemeProvider, StyledEngineProvider, createTheme } from '@mui/material/styles';


const theme = createTheme({
    typography: {
        fontFamily: ['Outfit', 'sans-serif'].join(',')
    },
});

const MainApp = (props) => {
    // Track all route changes in DataDog RUM
    useDataDogViewTracking();

    const { current_reseller, reseller_was_validated } = useSelector(state => state.resellerRedux)
    const lang = useSelector(state => state.commomRedux.language);


    useEffect(() => {
        if (current_reseller) {
            if (current_reseller.title)
                document.title = current_reseller.title; // change tab name

            // Update favicon dynamically
            const updateFavicon = (faviconUrl) => {
                const iconTypes = ['icon', 'apple-touch-icon', 'shortcut icon'];
                iconTypes.forEach(type => {
                    let favicon = document.querySelector(`link[rel="${type}"]`);
                    if (!favicon) {
                        favicon = document.createElement('link');
                        favicon.rel = type;
                        document.head.appendChild(favicon);
                    }
                    favicon.href = faviconUrl || "";
                });
            };

            if (current_reseller.favicon) {
                updateFavicon(current_reseller.favicon); // update favicon
            } else {
                updateFavicon(); // remove favicon if not provided
            }
        }
        else {
            if (reseller_was_validated)
                document.title = "Zonar Ignition"
        }
    }, [current_reseller, reseller_was_validated])

    return (
        <Fragment>
            <IntlProvider locale={lang} messages={locales[lang]}>
                <NotificationContainer />
                <Fragment>
                    {/* <StyledEngineProvider injectFirst>*/}
                    <ThemeProvider theme={theme}>
                        <Routes>
                            <Route path='/' element={<Navigate to="/app" />} />
                            <Route path={'/app/*'} element={<ModulesRoutes />} />
                            <Route path={'/reseller/:reseller/forgotPassword'} element={<ForgotPasswordView />} />
                            <Route path={'/reseller/:reseller'} element={<LoginView />} />
                            <Route path={'/login-social-media'} element={<LoginSocialMedia />} />
                            <Route path={'/login/*'} element={<LoginView />} />
                            <Route path={'/forgotPassword'} element={<ForgotPasswordView />} />
                            <Route path={'/confirmUser/*'} element={<ConfirmUserView />} />
                            <Route path={'/resetPassword/*'} element={<ConfirmUserView isResetPassword={true} />} />
                            <Route path={'/error'} element={<ErrorView />} />
                            <Route path={'/sharedVideo'} element={<SharedVideoView />} />
                            <Route path={'/sharedMedia/:type/:id'} element={<SharedMediaView />} />
                            <Route path={'/SharedLiveVideoSec/:deviceId/:readingId/:clipId'} element={<SharedLiveVideoSecView />} />
                            <Route path={'/videoAlert/:id'} element={<VideoAlertView />} />
                            <Route path={'/alertLog/:id'} element={<AlertLogView />} />
                            <Route path={'/etaLink/:code'} element={<EtaLink />} />
                            <Route path={'/test'} element={<Test />} />
                            <Route path={'/forceChangePassword'} element={<ForceChangePassword />} />
                            <Route path={'/debugUnit/:id'} element={<DebugUnit />} />
                            <Route path={'/shortCodes/:code'} element={<ShortCodesView />} />
                            <Route path={'/s/:code'} element={<ShortCodesView />} />
                            <Route path={'/error/:type'} element={<ErrorView />} />
                            <Route path={'/incident/:code'} element={<LiveIncident />} />
                            <Route path={'/downloadReport/:id'} element={<DownloadReportView />} />
                            <Route path="*" element={<Navigate to="/error" />} />
                        </Routes>
                    </ThemeProvider>
                    {/* </StyledEngineProvider> */}
                </Fragment>

            </IntlProvider>

        </Fragment>
    );
}

export default MainApp;
